import { useMemo } from 'react';
import { useWriteContract, useSendTransaction, usePublicClient, useConfig, useSwitchChain } from 'wagmi';
import { createWagmiWalletService, IWalletService } from '../services/walletService';

/**
 * Hook to get wallet service instance
 * Provides abstraction layer for wallet interactions
 */
export const useWalletService = (): IWalletService | null => {
  const { writeContractAsync } = useWriteContract();
  const { sendTransactionAsync } = useSendTransaction();
  const publicClient = usePublicClient();
  const config = useConfig();
  const { switchChainAsync } = useSwitchChain();

  const walletService = useMemo(() => {
    if (!writeContractAsync || !sendTransactionAsync || !publicClient || !config) {
      return null;
    }

    return createWagmiWalletService(
      writeContractAsync,
      sendTransactionAsync,
      publicClient,
      config,
      switchChainAsync
    );
  }, [writeContractAsync, sendTransactionAsync, publicClient, config, switchChainAsync]);

  return walletService;
};

